import { TariffType } from '@/config';

export type CompareTariffRowData = string | boolean | null;

export type CompareTariffRow = {
  key: string;
  section: string;
  data?: Partial<Record<TariffType, CompareTariffRowData>>;
};

export const compareTariffsData: CompareTariffRow[] = [
  {
    key: 'checks_per_year',
    section: 'essentials',
    data: {
      lite: '20 - 100',
      pro: '1,000 - 5,000',
      proPlus: '15,000 - 100,000+',
    },
  },
  {
    key: 'intelligence_sources',
    section: 'essentials',
  },
  {
    key: 'api_checking',
    section: 'essentials',
    data: {
      lite: false,
      pro: false,
      proPlus: true,
    },
  },
  {
    key: 'aml_check_reports',
    section: 'essentials',
  },
  {
    key: 'clarity_of_risk_data',
    section: 'data_visibility',
  },
  {
    key: 'pdf_report',
    section: 'features',
    data: {
      lite: false,
      pro: true,
      proPlus: true,
    },
  },
  {
    key: 'discount_on_other_services',
    section: 'features',
    data: {
      lite: false,
      pro: false,
      proPlus: '10%',
    },
  },
  {
    key: 'referral_program',
    section: 'features',
    data: {
      lite: true,
      pro: true,
      proPlus: true,
    },
  },
  {
    key: 'customer_support',
    section: 'features',
    data: {
      lite: true,
      pro: true,
      proPlus: true,
    },
  },
  {
    key: 'ofac_sanctions_compliance',
    section: 'features',
    data: {
      lite: 'Limited, Only TRX & BTC',
      pro: true,
      proPlus: true,
    },
  },
  {
    key: 'address_transaction_monitoring',
    section: 'features',
    data: {
      lite: false,
      pro: false,
      proPlus: true,
    },
  },
  {
    key: 'kyt_api_access',
    section: 'features',
    data: {
      lite: true,
      pro: true,
      proPlus: true,
    },
  },
  {
    key: 'kyc_api_access',
    section: 'features',
    data: {
      lite: false,
      pro: false,
      proPlus: true,
    },
  },
  {
    key: 'service_clustering',
    section: 'features',
    data: {
      lite: false,
      pro: false,
      proPlus: true,
    },
  },
  {
    key: 'compliance_with_aml_d5_fatf_and_mica_standards',
    section: 'features',
    data: {
      lite: false,
      pro: false,
      proPlus: true,
    },
  },
  {
    key: 'crypto_aml_compliance',
    section: 'features',
    data: {
      lite: false,
      pro: false,
      proPlus: true,
    },
  },
];

export const SECTIONS_ORDER = [
  'essentials',
  'data_visibility',
  'features',
] as const;
